import { createMuiTheme } from '@material-ui/core';

export const theme = createMuiTheme({
  zIndex: {
    modal: '99999',
  },
});
